import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { Tour, ToursState, FetchToursPayload } from './Tours.types';

const initialState: ToursState = {
	tours: [],
	toursById: {},
	loading: false,
	error: null,
	currentUrl: '',
	tourConfigUrl: 'http://localhost:3000/tour.js', // Default URL
	theme: 'light',
	floSpaceId: '',
};

const toursSlice = createSlice({
	name: 'tours',
	initialState,
	reducers: {
		fetchTourByIdRequest: (
			state,
			action: PayloadAction<{ tourId: string; floSpaceId?: string }>
		) => {
			state.loading = true;
			state.error = null;
			if (action.payload.floSpaceId) {
				state.floSpaceId = action.payload.floSpaceId;
			}
		},
		fetchTourByIdSuccess: (state, action: PayloadAction<Tour>) => {
			state.loading = false;
			state.tours = [action.payload]; // Store single tour in array for consistency
			state.error = null;
		},
		fetchTourByIdFailure: (state, action: PayloadAction<string>) => {
			state.loading = false;
			state.error = action.payload;
			state.tours = [];
		},
		clearTours: (state) => {
			state.tours = [];
			state.error = null;
			state.currentUrl = '';
		},
	},
});

// Action to update the tour configuration URL
export const setTourConfigUrl = (url: string) => ({
	type: 'tours/setTourConfigUrl',
	payload: url,
});

export const {
	fetchTourByIdRequest,
	fetchTourByIdSuccess,
	fetchTourByIdFailure,
	clearTours,
} = toursSlice.actions;

// Selector to get the current tour configuration URL
export const selectTourConfigUrl = (state: { tours: ToursState }) =>
	state.tours.tourConfigUrl;

// Selector to get the current tour state
export const selectToursState = (state: { tours: ToursState }) => state.tours;

// Add an extra reducer to handle the setTourConfigUrl action
const extendedReducer = (state = initialState, action: any) => {
	if (action.type === 'tours/setTourConfigUrl') {
		return {
			...state,
			tourConfigUrl: action.payload,
		};
	}
	return toursSlice.reducer(state, action);
};

export default extendedReducer;
